import { ProductState } from './types'

export const productState: ProductState = {
  product: null,
  currentVariant: null
}
